var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "follow" },
    [
      _c("img", {
        attrs: {
          src: _vm.assetsImages("./conectar_tartaruga_nara.png"),
          alt: "conectar tartaruga",
          loading: "lazy"
        }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "container" }, [
        _c(
          "h2",
          { staticClass: "follow-title text-center font-weight-bolder" },
          [_vm._v("acompanhe a gente!")]
        ),
        _vm._v(" "),
        _c("h3", { staticClass: "follow-sub-title text-center" }, [
          _vm._v("receba as novidades da Taba em primeira mão:")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row justify-content-center" }, [
          _c("div", { staticClass: "col-12" }, [
            _c(
              "div",
              {
                staticClass:
                  "form-row align-items-center justify-content-center d-flex"
              },
              [
                _c("div", [
                  _c("div", { staticClass: "input-group mb-2 mail-div" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.followUs.email,
                          expression: "followUs.email"
                        }
                      ],
                      staticClass: "form-control",
                      class: { "is-invalid": _vm.$v.followUs.email.$error },
                      attrs: {
                        id: "inlineFormInputGroup",
                        placeholder: "Seu email aqui",
                        type: "email"
                      },
                      domProps: { value: _vm.followUs.email },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.followUs, "email", $event.target.value)
                        }
                      }
                    })
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "ml-2",
                    class: { "is-invalid": _vm.$v.followUs.email.$error }
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-success follow-btn mb-2",
                        attrs: { type: "submit" },
                        on: {
                          click: function($event) {
                            return _vm.action()
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n                                OK\n                            "
                        )
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "validation-invalid-feedback",
                  { attrs: { params: _vm.$v.followUs.email.$params } },
                  [
                    _vm._v(
                      "\n                        Caracteres especiais não são permitidos\n                    "
                    )
                  ]
                )
              ],
              1
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("modal-send-information", {
        attrs: {
          msgSuccess: {
            subtitle: "obrigada por se inscrever na nossa newsletter"
          },
          "show-modal": _vm.displayProcessingInformation,
          success: _vm.responseSuccess,
          prefix: "follow-us"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /Users/simon/code/ataba-wordpress-site/web/app/themes/rits/node_modules/vue-loader/lib/loaders/templateLoader.js?{}!/Users/simon/code/ataba-wordpress-site/web/app/themes/rits/node_modules/vue-loader/lib?{}!./scripts/vue/components/common/FollowUs.vue?vue&type=template&id=0130fd8e&
// module id = 54
// module chunks = 1 2